import { Dictionary } from "@/types/base";
import { makeAutoObservable } from "mobx";
import { formatTableData, getKeyValueMap, getTableForSearch } from "./utils";
import {
  KeywordsJSONType,
  WordEntityTypeWithParentKeys,
  WordTableTypeWithParentKeys,
} from "./type";

type WordTableDatasetType = {
  data: WordTableTypeWithParentKeys;
  searchList: WordEntityTypeWithParentKeys[];
  keyValueMap: Dictionary;
  nameDict: KeywordsJSONType["dictionary"];
};

const getDefaultDataset = (): WordTableDatasetType => ({
  data: [],
  searchList: [],
  keyValueMap: {},
  nameDict: {},
});

export type WordTableNames = "promptKeywords" | "negativePromptKeywords" | "animeKeywords";
class WordTableStore {
  promptKeywords: WordTableDatasetType = getDefaultDataset();
  negativePromptKeywords: WordTableDatasetType = getDefaultDataset();
  animeKeywords: WordTableDatasetType = getDefaultDataset();

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setKeywordsDataset = (key: WordTableNames, json: KeywordsJSONType) => {
    const { data = [], dictionary: nameDict = {} } = json ?? {};
    const dataWithParentKeys = formatTableData(data);
    const listForSearch = getTableForSearch(data);
    const keyValueMap = getKeyValueMap(data);

    this[key] = {
      data: dataWithParentKeys,
      searchList: listForSearch,
      keyValueMap,
      nameDict,
    };
  };
}

export const wordTableStore = new WordTableStore();
